import {
    projectOne,
    projectTwo,
    projectThree,
    projectFour,
    projectFive,
    projectSix,
    clientProject,
    webflowImg,
    grover,
    portfolio,
    portfolio2,
    clientPortal1,
    clientPortal2,
    clientPortal4,
    clientPortal3,
    clientPortal5,
    clientPortal6,
    clientPortal8,
    clientPortal9,
    clientPortal10,
    clientPortal20,
    clientPortal19,
    clientPortal7,
    clientPortal11,
    clientPortal12,
    clientPortal13,
    clientPortal14,
    clientPortal15,
    clientPortal16,
    clientPortal17, clientPortal18
} from "../../assets/index";
export const projectCardData = [
    {
        id: 1,
        link: "https://clientportal-staging.getonnet.dev/auth/login",
        title: "CLIENTPORTAL",
        subTitle: "MadebyNext.js,TypescriptandChakraUi",
        des:
            "I have worked at getonnet in Norway as a frontend web developer. where I have worked on this website. This is a private website so I can't show all the features and the GitHub link.",
        img: clientProject,
        // githubLink: "https://github.com/sajib925/baby-store-minimog",
        category: "Client Project"
    },
    {
        id: 2,
        link: "https://baby-store-minimog-c649.vercel.app",
        title: "E-COMMERCEWEBSITE",
        subTitle: "MadebyReact.jsandStyledComponents",
        des:
            "Thisisane-commerceportfoliowebsitethatissolelyforshowcasing.Itdisplaysacollectionofproductsandservices relatedtomyworkandexpertise.",
        img: projectOne,
        githubLink: "https://github.com/sajib925/baby-store-minimog",
        category: "E-Commerce"
    },
    {
        id: 3,
        link: "https://grover.vercel.app/",
        title: "E-COMMERCEWEBSITE",
        subTitle: "MadebyReact.jsandModuleCSS",
        des:
            "Thisisane-commerceportfoliowebsitethatissolelyforshowcasing.Itdisplaysacollectionofproductsandservices relatedtomyworkandexpertise.",
        img: grover,
        githubLink: "https://github.com/sajib925/grover",
        category: "E-Commerce"
    },
    {
        id: 4,
        link: "https://kacha-bazar-three.vercel.app/",
        title: "E-COMMERCEWEBSITE",
        subTitle: "MadebyNext.jsandTailwindCSS",
        des:
            "Thisisane-commerceportfoliowebsitethatissolelyforshowcasing.Itdisplaysacollectionofproductsandservices relatedtomyworkandexpertise.",
        img: projectTwo,
        githubLink: "https://github.com/sajib925/kacha-bazar",
        category: "E-Commerce"
    },
    {
        id: 5,
        link: "https://evemat-d81d99.webflow.io/",
        title: "LANDINGWEBSITE",
        subTitle: "MadebyWebflow",
        des:
            "Thisisalandingportfoliowebsitethatissolelyforshowcasing.Itdisplaysacollectionofproductsandservices relatedtomyworkandexpertise.",
        img: projectThree,
        githubLink: "#",
        category: "Webflow"
    },
    {
        id: 6,
        link: "https://landing-page-0c97b6.webflow.io/",
        title: "LANDINGWEBSITE",
        subTitle: "MadebyWebflow",
        des:
            "Thisisalandingportfoliowebsitethatissolelyforshowcasing.Itdisplaysacollectionofproductsandservices relatedtomyworkandexpertise.",
        img: webflowImg,
        githubLink: "#",
        category: "Webflow"
    },
    {
        id: 7,
        link: "https://admin-dashboard-syncfusion-tailwind-2p68.vercel.app/",
        title: "ADMINDASHBOARD",
        subTitle: "MadebyNext.jsandTailwindCSS",
        des:
            "Thisisadashboardportfoliowebsitethatissolelyforshowcasing.Itdisplaysacollectionofproductsandservices relatedtomyworkandexpertise.",
        img: projectFour,
        githubLink: "https://github.com/sajib925/admin-dashboard-syncfusion-tailwind",
        category: "Admin Dashboard"
    },
    {
        id: 8,
        link: "https://okiro-eight.vercel.app/",
        title: "BLOG WEBSITE",
        subTitle: "MadebyReact.jsandStyledComponents",
        des:
            "Thisisablogportfoliowebsitethatissolelyforshowcasing.Itdisplaysacollectionofproductsandservices relatedtomyworkandexpertise.",
        img: projectFive,
        githubLink: "https://github.com/sajib925/okiro",
        category: "Blog"
    },
    {
        id: 9,
        link: "https://pungent-rho.vercel.app/",
        title: "LANDINGWEBSITE",
        subTitle: "MadebyNext.jsandModuleCSS",
        des:
            "Thisisalandingportfoliowebsitethatissolelyforshowcasing.Itdisplaysacollectionofproductsandservices relatedtomyworkandexpertise.",
        img: projectSix,
        githubLink: "https://github.com/sajib925/pungent",
        category: "Landing"
    },
    {
        id: 10,
        link: "https://portfolio-mu-nine-36.vercel.app/",
        title: "PORTFOLIOWEBSITE",
        subTitle: "MadebyNext.jsandModuleCSS",
        des:
            "Thisisalandingportfoliowebsitethatissolelyforshowcasing.Itdisplaysacollectionofproductsandservices relatedtomyworkandexpertise.",
        img: portfolio2,
        githubLink: "https://github.com/sajib925/portfolio",
        category: "Portfolio"
    },
    {
        id: 11,
        link: "https://additional-portfolio.vercel.app/",
        title: "PORTFOLIOWEBSITE",
        subTitle: "MadebyNext.jsandModuleCSS",
        des:
            "Thisisalandingportfoliowebsitethatissolelyforshowcasing.Itdisplaysacollectionofproductsandservices relatedtomyworkandexpertise.",
        img: portfolio,
        githubLink: "https://github.com/sajib925/my-portfolio",
        category: "Portfolio"
    },
];


export const projectDetailsData = [
    {
        id: 1,
        img: clientPortal1
    },
    {
        id: 2,
        img: clientPortal2
    },
    {
        id: 3,
        img: clientPortal3
    },
    {
        id: 4,
        img: clientPortal4
    },
    {
        id: 5,
        img: clientPortal5
    },
    {
        id: 6,
        img: clientPortal6
    },
    {
        id: 7,
        img: clientPortal7
    },
    {
        id: 8,
        img: clientPortal8
    },
    {
        id: 9,
        img: clientPortal9
    },
    {
        id: 10,
        img: clientPortal10
    },
    {
        id: 11,
        img: clientPortal11
    },
    {
        id: 12,
        img: clientPortal12
    },
    {
        id: 13,
        img: clientPortal13
    },
    {
        id: 14,
        img: clientPortal14
    },
    {
        id: 15,
        img: clientPortal15
    },
    {
        id: 16,
        img: clientPortal16
    },
    {
        id: 17,
        img: clientPortal17
    },
    {
        id: 18,
        img: clientPortal18
    },
    {
        id: 19,
        img: clientPortal19
    },
    {
        id: 20,
        img: clientPortal20
    },

]